import { datadogRum } from '@datadog/browser-rum';

const NODE_ENV = process.env.NODE_ENV || 'local_dev';
const GIT_REVISION = process.env.GIT_REVISION || 'none';

datadogRum.init({
  applicationId: '43094f6e-d90e-45be-b52e-1d6504c18995',
  clientToken: 'pub391c3f3d86898d0dfa6b4b0e41f3ae31',
  site: 'datadoghq.com',
  service: 'partner-directory',
  version: GIT_REVISION,
  environment: NODE_ENV,
  sampleRate: 10,
  premiumSampleRate: 0,
  trackInteractions: true
});
